import { DateTime } from "luxon";

export function isString(value:unknown): value is string {
    return typeof value === "string";
}

export function isDate(value: unknown): value is Date {
    return value instanceof Date;
}

export function isDateTime(value: unknown): value is DateTime {
    return value instanceof DateTime;
}

export function typeCheckResponse<T>(x: any, expectedType: T): boolean {
    return typeof x === typeof expectedType;
}